import React from 'react';
import {Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {langService} from "../../../jwt/_services";
import LangTab from "../../../components/tabs/langTab";
import {langAwardsService} from "../../../jwt/_services/relations/langAwardService";
import {showLoader} from "../../../components/loader/loader";


class AwardLangs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: this.props.editMode,
            disableInputs : this.props.disableInputs,
            loading: false,

            award : this.props.award,
            langChilds: [],
            langAwardChilds: [],
        }

        this.setForm = this.setForm.bind(this);
        this.onNameChange = this.onNameChange.bind(this);

        this.getLangChilds = this.getLangChilds.bind(this);
        this.getFormulary = this.getFormulary.bind(this);
    }

    componentDidMount() {
        // ----------------------------------
        // Establece las opciones de idioma
        // ----------------------------------
        let langChilds = [];
        this.setState({loading: true});
        langService.getAll()
            .then(langOptions => {
                if (langOptions) {
                    langOptions.map((lang) => {
                        const langChild = {
                            lang: lang,
                            name: '',
                            id: '',
                        };
                        langChilds.push(langChild);
                        this.setState({langChilds, loading: false});
                    });
                }else {
                    this.setState({loading: false});
                }

            })
            .then( () => {
                // ----------------------------------
                // Consulta los idiomas guardados
                // ----------------------------------
                if (this.state.editMode){
                    this.setState({loading: true});
                    langAwardsService.search({id: this.state.award?.id})
                        .then((langAwardChilds) => {
                            this.setState({langAwardChilds});
                        })
                        .then(() => {
                            if (this.state.langAwardChilds && this.state.langAwardChilds.length > 0){
                                langChilds = this.combineLangChilds(this.state.langChilds, this.state.langAwardChilds);
                                this.setState({langChilds, loading: false});
                            }else {
                                this.setState({loading: false});
                            }
                        })
                }
            });
    }

    setForm(editMode, showList, data) {
        this.props.setForm(editMode, showList, data)
    }

    getLangChilds(){
        const langChilds = this.combineLangChilds(this.state.langChilds, this.state.langAwardChilds);

        return (langChilds ? langChilds : (this.state?.langChilds ? this.state?.langChilds : []));
    }

    changeDisabledInput(option){
        this.setState({disableInputs : option });
        this.getLangChilds(); // Refresh component
    }

    resetForm(){
        let langOption = [];
        this.state.langChilds.map((langC) => {
            const langChild = {
                lang: langC.lang,
                name: '',
                id: '',
            };
            langOption.push(langChild);
        });
        this.setState({langChilds: langOption, langAwardChilds: [], disableInputs : false});
        this.getLangChilds();
    }

    combineLangChilds(langOptions, langAwardChilds){
        try {
            if (langOptions && langAwardChilds && langOptions.length > 0 && langAwardChilds.length > 0){
                langOptions.map((child, index) => {
                    const langawardsIndex = langAwardChilds.findIndex(n => n.lang.id === child.lang.id);

                    if (langawardsIndex !== -1) {
                        // significa que si lo encontro
                        langOptions[index] = {
                            lang :  langAwardChilds[langawardsIndex].lang,
                            name :  langAwardChilds[langawardsIndex].name,
                            id :    langAwardChilds[langawardsIndex].id
                        }
                    }
                });

                return langOptions;
            }
        } catch (e) {
            console.log(e.message);
            return e.message;
        }
    }

    onNameChange(value, index, lang){

        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);

        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang : langChilds[langIndex].lang,
            name :  value ,
            id : langChilds[langIndex].id
        }

        // Le envia la información al componente padre
        this.props.updateItem(langChilds);

        this.setState({
            langChilds : langChilds,
            langAwardChilds : langChilds
        });
    }

    getFormulary(child, index, disableInputs){
        return (
            <Form>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >Nombre</Label>
                            <Input type="name" name="Name"
                                   placeholder="Ingrese nombre"
                                   value= { child.name }
                                   onChange={e => this.onNameChange(e.target.value, index, child.lang )}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }

    render() {

        return (
            <div>
                <Row>
                    {this.state.loading ? showLoader() : null}
                    <Col md="12">
                        <LangTab
                            key={"LangTabId"}
                            langChilds={this.state.langChilds}
                            onNameChange={this.onNameChange}
                            getLangChilds={this.getLangChilds}
                            getFormulary={this.getFormulary}
                            disableInputs={this.state.disableInputs}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

}



export default AwardLangs;
